import { ReactNode } from 'react';
import classes from './OrderConfirmComponents.module.scss';

type OrderConfirmRowProps = {
  label: string;
  value?: ReactNode;
  testIdBase?: string;
};

export const OrderConfirmRow = ({ label, value, testIdBase }: OrderConfirmRowProps) => {
  return (
    <div
      className={classes.rowContainer}
      data-testid={testIdBase}
    >
      <span
        className={classes.label}
        data-testid={testIdBase ? `${testIdBase}-label` : undefined}
      >
        {label}
      </span>
      <span
        className={classes.value}
        data-testid={testIdBase ? `${testIdBase}-value` : undefined}
      >
        {value ?? '-'}
      </span>
    </div>
  );
};

export const OrderConfirmBlock = ({ children }: { children: ReactNode }) => {
  return <div className={classes.blockContainer}>{children}</div>;
};
